import React from 'react';

import { Box, Stack, Text } from '@atlaskit/primitives/compiled';

import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { useImages } from '../api/useImages/useImages';

export const VisualKnowledgeCard = (): React.JSX.Element | null => {
	const { commonAttributes, sourceProduct } = useAIAnswerContext();
	const { cloudId, workspaceId, query } = commonAttributes;

	const { images, loading, error } = useImages({
		searchQuery: query,
		cloudId,
		workspaceId,
		product: sourceProduct ?? '',
	});

	// TODO: Replace loading placeholder with final loading state UI
	// https://hello.jira.atlassian.cloud/browse/CCSEARCH-6579
	if (loading) {
		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
		return <>Loading images...</>;
	}

	// TODO: Replace error placeholder with final error state UI
	// https://hello.jira.atlassian.cloud/browse/CCSEARCH-6579
	if (error) {
		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
		return <>Error fetching images</>;
	}

	// TODO: Replace empty state placeholder with final empty state UI
	// https://hello.jira.atlassian.cloud/browse/CCSEARCH-6579
	if (!images || images.length === 0) {
		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
		return <>No images found</>;
	}

	// TODO: Replace placeholder with `Images` component from `@atlassian/smart-knowledge-cards`
	// https://hello.jira.atlassian.cloud/browse/CCSEARCH-6581
	return (
		<Stack testId="visual-knowledge-card" space="space.050">
			<Box>
				<Text weight="semibold">
					{images.length}{' '}
					{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
					{images.length === 1 ? 'image found' : 'images found'}
				</Text>
			</Box>
			{
				images.length > 0 && (
					<ul>
						{images.map((image, index) => (
							<li key={`${image.thumbnailUrl}-${index}`}>
								{image.thumbnailUrl}
							</li>
						))}
					</ul>
				)
			}
		</Stack>
	);
};
